module.controller('cardBalanceCtrl', ['$scope', '$state', 'baseURI', '$http', 'Transform', 'Session', 'brandService',  function($scope, $state, baseURI, $http, Transform, Session, brandService) {

    $scope.showCardNumberInfoModal = false;
    $scope.showCvvNumberInfoModal = false;
    $scope.loading = false;

    $scope.login = function() {
        $scope.loading = true;
        $http({
            url: baseURI + 'oauth/lite/login',
            method: 'POST',
            headers: {'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'},
            data: Transform.encode({
                CardNumber: $scope.formData.cardNumber,
                CVV: $scope.formData.cvvNumber,
                _key: $scope.brand.api_key
            })
        }).then(function(loginResponse) {
            var brand = loginResponse.data.Data.WebAppBrandKey;
            var token = loginResponse.data.access_token;
            var liteBrand = brandService.getBrand(brand);

            Session.setLiteBrand(liteBrand);

            $http({
                url: baseURI + 'lite/card/balance',
                method: 'GET',
                headers: {
                    Authorization: 'Bearer ' + token
                }
            }).then(function(balanceResponse) {
                var balance = balanceResponse.data.Data.Balance.toString();
                Session.setLiteBalance(balance);
                $state.go('cardBalance.viewCardBalance', {brandName: liteBrand.name});
                $scope.loading = false;
            }).catch(function(err) {
                $scope.loading = false;
                $scope.showCardBalanceError = true;
                $scope.cardBalanceErrorMessage = "We were unable to get your card balance at this time. Please try again later.";
                $scope.showCardBalanceErrorMessage = 'Error: ' + err;
            });
        }).catch(function(err) {
            $scope.loading = false;
            $scope.showCardBalanceError = true;
            $scope.cardBalanceErrorMessage = "We were unable to verify your card information at this time. Please try again later.";
            $scope.showCardBalanceErrorMessage = 'Error: ' + err.data;
        });
    };

}]);
